import type { FC } from 'react';

import {
	BookingOptionsDto,
	LegView,
	ProdtVoucherView,
} from '@mopla/data-models';

import { BookingVoucherFormV2 } from './BookingVoucherFormV2';
import { BookingVoucherValidChip } from './BookingVoucherValidChip';
import { useRedeemVoucherForm } from './hooks';

export interface IBookingVoucherV2Props {
	leg: LegView;
	bookingOptions: BookingOptionsDto;
	onValidateSuccess?(validVoucher: ProdtVoucherView): void;
}

/**
 * V2 Voucher component with simplified UI:
 * - Text button instead of full button
 * - Error shown in input helper text
 * - Success shows chip with delete
 *
 * Reuses useRedeemVoucherForm hook for business logic.
 */
export const BookingVoucherV2: FC<IBookingVoucherV2Props> = ({
	leg,
	bookingOptions,
	onValidateSuccess,
}) => {
	const {
		control,
		onSubmit,
		isSubmitting,
		isSubmitDisabled,
		validationError,
		validVoucher,
		resetForm,
		clearError,
	} = useRedeemVoucherForm({ leg, bookingOptions, onValidateSuccess });

	if (validVoucher && !isSubmitting) {
		return (
			<BookingVoucherValidChip
				voucherCode={validVoucher.code}
				discountValue={validVoucher.calculatedValueCents}
				onDelete={resetForm}
			/>
		);
	}

	return (
		<BookingVoucherFormV2
			control={control}
			onSubmit={onSubmit}
			isSubmitting={isSubmitting}
			isSubmitDisabled={isSubmitDisabled}
			error={validationError}
			onCodeChange={clearError}
		/>
	);
};
